import React from "react";
import { Modal } from "antd";
const AdminLogsMessageModal = ({
  openLogsMessageModal,
  setOpenLogsMessageModal,
  logRecord,
}) => {
  const closeLogsModal = () => {
    setOpenLogsMessageModal(false);
  };

  return (
    <>
      <Modal
        open={openLogsMessageModal}
        onCancel={closeLogsModal}
        footer={null}
        width={window.innerWidth > 760 ? "50%" : "95%"}
        centered
      >
        <div className="admin-logs-message-modal-container">
          {JSON.stringify(logRecord)}
        </div>
      </Modal>
    </>
  );
};

export default AdminLogsMessageModal;
